// Types
import type { ThemeStyleProps } from '@/types/config/theme-style'

const ThemeConfig: ThemeStyleProps = {
	color: '#ff8484',
	drawerWidth: 260
}

export default ThemeConfig
